
// pdp-opt.js
document.addEventListener('DOMContentLoaded', function(){
  try {
    var gallery = document.querySelector('[data-product-gallery], .product-gallery, .product__media, .product-media, .product__media-list, .media');
    if (gallery) {
      var imgs = gallery.querySelectorAll('img');
      if (imgs.length) {
        var first = imgs[0];
        try {
          first.setAttribute('fetchpriority', 'high');
          first.setAttribute('decoding', 'async');
          if (first.hasAttribute('loading')) first.removeAttribute('loading');
        } catch(e){}
        for (var i=1;i<imgs.length;i++){
          if (!imgs[i].hasAttribute('loading')) imgs[i].setAttribute('loading','lazy');
          imgs[i].setAttribute('decoding','async');
        }
      }
    }
  } catch(e){ console.warn('pdp-opt error', e); }
});
